import React from 'react';
import Link from 'next/link';
import AppLogo from '@/components/ui/AppLogo';
import Icon from '@/components/ui/AppIcon';

export default function Footer() {
  return (
    <footer className="border-t border-fog-gray bg-white">
      <div className="max-w-7xl mx-auto px-6 py-10">
        {/* Top row */}
        <div className="flex flex-col md:flex-row items-start justify-between gap-8 mb-8">
          {/* Logo + links */}
          <div className="flex flex-col gap-4">
            <AppLogo size={22} text="remotejobehire" />
            <nav className="flex flex-wrap items-center gap-6">
              <a href="#jobs" className="text-sm font-medium text-slate-light hover:text-slate-dark transition-colors">Browse</a>
              <a href="#companies" className="text-sm font-medium text-slate-light hover:text-slate-dark transition-colors">Companies</a>
              <a href="#post-role" className="text-sm font-medium text-slate-light hover:text-slate-dark transition-colors">Post a Role</a>
              <Link href="/privacy" className="text-sm font-medium text-slate-light hover:text-slate-dark transition-colors">Privacy</Link>
              <Link href="/terms" className="text-sm font-medium text-slate-light hover:text-slate-dark transition-colors">Terms</Link>
            </nav>
          </div>

          {/* Contact details */}
          <div className="flex flex-col gap-2">
            <p className="text-sm font-semibold text-slate-dark mb-1">Contact Us</p>
            <a href="mailto:Support@remotejobehire.com" className="flex items-center gap-2 text-sm text-slate-light hover:text-blue-accent transition-colors">
              <Icon name="EnvelopeIcon" size={15} />
              Support@remotejobehire.com
            </a>
            <a href="tel:+13156908876" className="flex items-center gap-2 text-sm text-slate-light hover:text-blue-accent transition-colors">
              <Icon name="PhoneIcon" size={15} />
              +1 315-690-8876
            </a>
            <div className="flex items-start gap-2 text-sm text-slate-light">
              <Icon name="MapPinIcon" size={15} className="mt-0.5 shrink-0" />
              <span>1309 Coffeen Avenue STE 1200,<br />Sheridan, Wyoming 82801, USA</span>
            </div>
          </div>
        </div>

        {/* Bottom row */}
        <div className="flex flex-col sm:flex-row items-center justify-between gap-4 pt-6 border-t border-fog-gray">
          <span className="text-sm text-slate-light">© 2026 remotejobehire. All rights reserved.</span>
          <div className="flex items-center gap-4">
            <a href="#" aria-label="Twitter" className="text-slate-light hover:text-slate-dark transition-colors">
              <Icon name="GlobeAltIcon" size={18} />
            </a>
            <a href="#" aria-label="LinkedIn" className="text-slate-light hover:text-slate-dark transition-colors">
              <Icon name="LinkIcon" size={18} />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}